/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { NavigationGuardNext, Route } from 'vue-router';
import { checkPermissions, ifAuthenticated } from '../routeValidation';
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { buyersPermissions } from '@/routes/menus/permissions/index';

const Buyers = () =>
  import(
    /* webpackChunkName: "Buyers" */ '@/views/Buyers/index.vue'
  );

const permissionsPages = {
  path: '/',
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  name: 'buyers',
  children: [
    {
      path: '/buyers',
      component: Buyers,
      beforeEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>): void {
        checkPermissions(to, from, next, buyersPermissions);
      },
      meta: {
        navbarType: 'light',
      },
    }
  ],
};

export default permissionsPages;
